import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export default function AGB() {
  useEffect(() => {
    document.title = "AGB | ViraAi";
  }, []);
  return (
    <div style={{ backgroundColor: "#0A0A0A", minHeight: "100vh", color: "#F0EDE8", fontFamily: "'Inter', sans-serif" }}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#C9A84C] hover:text-[#E0C375] transition-colors mb-10 text-sm font-medium"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1
          className="text-3xl sm:text-4xl font-black text-[#F0EDE8] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Allgemeine Geschäftsbedingungen
        </h1>

        <div className="space-y-8 text-[#9A9A9A] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 1 Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Kaufverträge, die
              zwischen Magic Design Agents UG (haftungsbeschränkt), vertreten durch Luca Berg
              (nachfolgend „Anbieter"), und den Käufern (nachfolgend „Kunde") über die Plattform
              payhip.com geschlossen werden.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 2 Vertragsgegenstand</h2>
            <p>
              Gegenstand des Vertrages ist der Erwerb eines digitalen Produkts in Form eines
              Online-Videokurses mit dem Titel „Die AI Agentur Methode". Der Kurs umfasst
              22 Video-Lektionen in 7 Modulen mit einer Gesamtlänge von ca. 5 Stunden sowie
              zugehörige Materialien und Vorlagen. Der Zugang ist nach Kauf dauerhaft
              (lebenslang) und nicht auf eine bestimmte Nutzungsdauer beschränkt.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 3 Vertragsschluss</h2>
            <p>
              Der Vertrag kommt durch den Abschluss des Kaufprozesses auf der Plattform Payhip
              zustande. Mit dem Abschluss des Kaufprozesses erkennt der Kunde diese AGB an.
              Der Anbieter bestätigt den Kauf per E-Mail mit Zugangslink zum digitalen Produkt.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 4 Preise und Zahlung</h2>
            <p>
              Der aktuelle Preis des Kurses ist auf der Produktseite angegeben. Der Preis ist
              ein Einmalpreis ohne wiederkehrende Zahlungen (kein Abo). Die Zahlung erfolgt
              über die von Payhip angebotenen Zahlungsmethoden. Der Kunde erhält nach
              erfolgreicher Zahlung sofortigen Zugang zum Kurs.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 5 Widerrufsrecht</h2>
            <p>
              Bei digitalen Produkten, die sofort nach dem Kauf zugänglich gemacht werden,
              erlischt das Widerrufsrecht gemäß § 356 Abs. 5 BGB, wenn der Verbraucher
              ausdrücklich zugestimmt hat, dass der Anbieter mit der Ausführung des Vertrags
              vor Ablauf der Widerrufsfrist beginnt, und seine Kenntnis davon bestätigt hat,
              dass er durch seine Zustimmung mit Beginn der Ausführung des Vertrags sein
              Widerrufsrecht verliert.
              <br /><br />
              Mit dem Abschluss des Kaufs und dem Erhalt des Zugangslinks erlischt das
              Widerrufsrecht für dieses digitale Produkt.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 6 Nutzungsrechte</h2>
            <p>
              Mit dem Kauf erhält der Kunde ein nicht-übertragbares, nicht-exklusives Recht
              zur persönlichen Nutzung der Kursinhalte. Die Weitergabe, Vervielfältigung oder
              kommerzielle Nutzung der Kursinhalte — auch in Teilen — ist ohne ausdrückliche
              schriftliche Zustimmung des Anbieters untersagt.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 7 Ergebnisversprechen</h2>
            <p>
              Die auf der Produktseite dargestellten Einkommensergebnisse sind Beispiele von
              echten Kursteilnehmern. Der Anbieter garantiert keine spezifischen Einkommens-
              oder Erfolgsergebnisse. Individuelle Ergebnisse hängen von Einsatz, Fleiß,
              Marktbedingungen und anderen Faktoren ab.
            </p>
          </section>

          <section>
            <h2 className="text-[#F0EDE8] font-bold text-lg mb-3">§ 8 Anwendbares Recht</h2>
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand für alle
              Streitigkeiten ist Bochum, soweit dies gesetzlich zulässig ist.
            </p>
          </section>

          <section>
            <p className="text-xs text-[#9A9A9A]/60">
              Stand: Juni 2026 · Magic Design Agents UG (haftungsbeschränkt) · Bochum
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
